import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';

// import {Routing} from './routes';
import Controller from './app/Controller';
import * as serviceWorker from './serviceWorker';

import '@piggybank/core/lib/styles.css';
import '@piggybank/form/lib/styles.css';
import './utils/tealium/tealium';

if (process.env.NODE_ENV !== 'production') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React);
}

ReactDOM.render(<Controller />, document.getElementById('root'));
serviceWorker.unregister();
